import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useConst } from '@fluentui/react-hooks';
import { useHistory } from 'react-router-dom';
import { ContextualMenuItemType } from '@fluentui/react/lib/ContextualMenu';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { Persona, PersonaSize } from '@fluentui/react/lib/Persona';
import { Toggle } from '@fluentui/react/lib/Toggle';
import storage from '../../storage';
import auth from '../../api/auth';
import { TOKEN, USER } from '../../constants/cookies';
import { toggleTheme } from '../../stores/theme/actions';
import { getIsDarkTheme } from '../../stores/theme/getters';

const textSize = 10;

const limitText = (name, size) =>
  name.slice(0, size) + (name.length > size ? '...' : '');

const decorateDisplayName = (name, size) => {
  let decoratedName = '';
  // get first name
  decoratedName = name.split(' ')[0];
  decoratedName = limitText(decoratedName, size);

  return decoratedName;
};

const ThemeToggle = ({ text }) => {
  const dispatch = useDispatch();
  const isDarkTheme = useSelector(getIsDarkTheme);

  const onToggleTheme = () => {
    dispatch(toggleTheme());
  };

  return (
    <div className="app-bar-context-menu__change-theme">
      <Toggle
        defaultChecked={isDarkTheme}
        onText={text}
        offText={text}
        onChange={onToggleTheme}
      />
    </div>
  );
};

function Menu({ name }) {
  const history = useHistory();

  const logOut = (e) => {
    e.preventDefault();

    auth
      .logout()
      .then((res) => {
        // clear login tokens from local storage if exists
        console.log(res);
        storage.deleteItem(TOKEN);
        storage.deleteItem(USER);
        sessionStorage.clear();

        // refresh
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const menuItems = (name) => {
    return [
      {
        key: 'Name',
        itemType: ContextualMenuItemType.Header,
        text: name,
      },
      {
        key: 'theme',
        text: 'Dark Mode',
        onRender: (props) => <ThemeToggle {...props} />,
      },
      {
        key: 'profile',
        text: 'Profile',
        onClick: () => history.push('/profile'),
      },
      {
        key: 'logout',
        text: 'Logout',
        onClick: logOut,
      },
    ];
  };

  const menuProps = useConst(() => ({
    shouldFocusOnMount: true,
    items: menuItems(name),
  }));

  const displayName = decorateDisplayName(name, textSize);

  return (
    <DefaultButton menuProps={menuProps} className="app-bar-context-menu">
      <Persona
        className="app-bar-context-menu__persona"
        text={name}
        size={PersonaSize.size24}
        hidePersonaDetails
      />
      <span>{displayName}</span>
    </DefaultButton>
  );
}

Menu.defaultProps = {
  name: '',
};

Menu.propTypes = {
  name: PropTypes.string,
};

// eslint-disable-next-line react/display-name
export default function () {
  const { name = '' } = storage.getItem(USER);

  return <>{name && name.trim() && <Menu name={name} />}</>;
}
